<template>
	<div id="buildingIntro">
		<!-- <img src="../../images/combinationIntro/combinationIntro1.jpg" alt="" />
		<img src="../../images/combinationIntro/combinationIntro2.jpg" alt="" />
		<img src="../../images/combinationIntro/combinationIntro3.jpg" alt="" />
		<img src="../../images/combinationIntro/combinationIntro4.jpg" alt="" /> -->
        <div class="fixedIconBox" @click="toEnterForm">
            <span class="titleText">申请入驻</span>
        </div>
        <div class="firstSection">
            <div class="backBtn" @click="back"  v-if="!isFromYjj">
                <i class="el-icon-arrow-left"></i> 返回
            </div>
            <img src="../../images/newImages/bg_zongheti.png" alt="">
            <div class="floatBox">
                <div class="title bold">浙江省服装产业创新服务综合体</div>
                <div class="subtitle">聚空间、金融、政策、产业配置、互联网平台为一体的服装产业综合创新服务</div>
            </div>

        </div>
        <div class="secondSection liangduanduiqi">
            浙江省服装产业创新服务综合体是浙江省公布的产业创新服务综合体第一批创建单位,以余杭服装产业集群为首期核心资源,通过一年的努力,在2019年产业运营直接覆盖面积将达到30万平方;综合体产业互联网平台现已集聚设计师247名,版师134名;制造工厂186家;面辅料供应商367家、品牌及终端门店199家;中介服务机构23家;品牌孵化企业4家;平台实现累计交易额3598万元;线下园区建设有设计师空间、面料展示、中央版房、样衣展示、共享工厂、智能工厂、智慧门店等。在数字经济时代大趋势下,服装综合体以服装产业互联网平台为纽带,整合服装产业全产业资源,通过政策引导、数字技术、金融支持、产业园区空间企业服务等打造产业级线上线下融合的数字时尚时代。
        </div>
        <div class="thirdSection">
            <div class="imgBox">
                <img src="../../images/newImages/img_zongheti.png" alt="">
            </div>
            <div class="imgDes">
                <img src="../../images/newImages/ic_jiantou.png" alt="" class="arrowIcon">
                <span class="text">综合体实拍图</span>
                
            </div>
        </div>
        <div class="thirdSection">
            <div class="imgBox">
                <img src="../../images/newImages/img_chanyebuju.png" alt="">
            </div>
            <div class="imgDes">
                <img src="../../images/newImages/ic_jiantou.png" alt="" class="arrowIcon">
                <span class="text">临平新城综合体产业布局</span>
                
            </div>
        </div>
        <div class="bottomImg">
            <img src="../../images/newImages/img_logo_dibu.png" alt="" class="footImg">

        </div>
        <div class="lastButtonSection">
            <a href="tel:0571-86221010">
                <button  class="btn-red reverse">
                    
                        <img src="../../images/newImages/but_ic_phone.png" alt="" class="btnIcon">
                        联系我们
                </button>
            </a>
            <button  class="btn-red " @click="toEnterForm">
                <img src="../../images/newImages/but_ic_ruzhu.png" alt="" class="btnIcon">
                入驻综合体
            </button>
        </div>
	</div>
</template>

<script>
    import {        setCookie,        phoneReg,        codeReg,        filterPhoneNum,        GetRequest    } from '@/assets/common.js'
	export default {
		data() {
			return {
                isFromYjj:'',
                paramObj:'',
                code:'',
			}
		},
		methods: {
            back(){
                this.$router.back()
            },
            toEnterForm() {
                this.$router.push({
                    name: 'BuildingEnterForm'
                });
            
            },

		},
		mounted() {
            //判断是否返回即可，不需要重新登录
            this.paramObj = GetRequest()
            console.log(this.paramObj )
            this.code = this.paramObj.c
            this.isFromYjj=this.code?true:false
        }
	}
</script>

<style lang="less" scoped="scoped">
img{width: 100%;}
#buildingIntro{
    
    .firstSection{
        position: relative;
        .floatBox{
            color:#fff; position: absolute;top:0;left:0; right: 0;text-align: center;
            .title{font-size: 0.48rem;padding:1.9rem 0 0.4rem; line-height: 0.48rem;}
            .subtitle{font-size: 0.31rem;text-align: center;line-height: 0.44rem; width: 5.74rem;display: inline-block;}
        }
    }
    .secondSection{
        padding:0.8rem 0.44rem; background: #fff; font-size: 0.36rem; line-height: 0.68rem; color:#333;
    }
    .thirdSection{
        padding:0 0.44rem; background: #fff; padding-bottom: 0.8rem;
        .imgBox{
            img{width: 100%;}
        }
        .imgDes{
            margin-top:0.27rem; font-size: 0.3rem; color:#999; line-height: 0.42rem;
            .arrowIcon{width: 0.24rem;}
            .text{}
        }
    }
}

</style>


// WEBPACK FOOTER //
// src/page/introPage/buildingIntro.vue